import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["arrow", "componentEl", "attached", "children", "className", "componentRef", "margin", "padding", "fullWidth"];
import React from 'react';
import PropTypes from 'prop-types';
import { componentElDefaults, componentElPropTypes } from '../customPropTypes/componentEl';
import { classNamePropTypes, addClassNames } from '../customPropTypes/classNames';
import { addSpacingClasses, marginPropTypes, paddingPropTypes } from '../customPropTypes/spacing';
import BoxTitle from './BoxTitle';
import BoxContent from './BoxContent';
import { jsx as _jsx } from "react/jsx-runtime";
function Box(_ref) {
  var arrow = _ref.arrow,
    Component = _ref.componentEl,
    attached = _ref.attached,
    children = _ref.children,
    className = _ref.className,
    componentRef = _ref.componentRef,
    margin = _ref.margin,
    padding = _ref.padding,
    fullWidth = _ref.fullWidth,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var cssClasses = ['st_box'];
  cssClasses = addClassNames(className, cssClasses);
  cssClasses = addSpacingClasses({
    margin: margin,
    padding: padding,
    cssClasses: cssClasses
  });
  if (arrow) cssClasses.push("st_box--arrow st_box--arrow-".concat(arrow));
  if (attached) cssClasses.push("st_box--attached-".concat(attached));
  if (fullWidth) cssClasses.push('st_box--fullwidth');

  // set different default padding for fullwidth boxes
  var childrenWithProps = React.Children.map(children, function (child) {
    if (fullWidth && /*#__PURE__*/React.isValidElement(child) && child.type.displayName === 'Box.Title' && child.props.padding) {
      return /*#__PURE__*/React.cloneElement(child, {
        padding: {
          vertical: 'smd',
          horizontal: 'md'
        }
      });
    }
    if (fullWidth && /*#__PURE__*/React.isValidElement(child) && child.type.displayName === 'Box.Content' && child.props.padding) {
      return /*#__PURE__*/React.cloneElement(child, {
        padding: {
          horizontal: 'md',
          top: 'md',
          bottom: 'md'
        }
      });
    }
    return child;
  });
  var localProps = {};
  if (componentRef) localProps.ref = componentRef;
  return /*#__PURE__*/_jsx(Component, _extends({
    className: cssClasses.join(' ')
  }, localProps, otherProps, {
    children: childrenWithProps
  }));
}
process.env.NODE_ENV !== "production" ? Box.propTypes = {
  /** dom element or component to use for outermost wrapper */
  componentEl: componentElPropTypes,
  /** ref for element */
  componentRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]),
  /** extra CSS classes, if any */
  className: classNamePropTypes,
  /** margin for box, if any */
  margin: marginPropTypes,
  /** padding for box contents. Setting this overrides defaults and does not extend them */
  padding: paddingPropTypes,
  /** display a pointy arrow on one of the side */
  arrow: PropTypes.oneOf(['top', 'left', 'right', 'bottom', 'top-left', 'top-right']),
  /** whether this box is attached to another box, so we don't have double borders */
  attached: PropTypes.oneOf(['top', 'bottom']),
  /** full width version meant to go from edge to edge of viewport window */
  fullWidth: PropTypes.bool
} : void 0;
Box.defaultProps = {
  componentEl: componentElDefaults,
  componentRef: null,
  className: null,
  margin: null,
  padding: null,
  arrow: null,
  attached: null,
  fullWidth: false
};
Box.Title = BoxTitle;
Box.Title.displayName = 'Box.Title';
Box.Content = BoxContent;
Box.Content.displayName = 'Box.Content';
export default Box;